import React, { useEffect, useMemo, useRef, useState } from 'react';
import CustomTable from '../../share-components/CustomTable';
import { useNavigate } from 'react-router-dom';
import { PAGE_ORDER_LIST, ROUTE_ORDER_DELI_EDIT, ROUTE_ORDER_DETAILS, ROUTE_ORDER_EDIT, ROUTE_ORDER_LIST } from '../../constants/routeConstants';
import { Accordion, Button, Card } from 'react-bootstrap';
import { useAppContext } from '../../share-components/AppContext';
import {
    currentMonth, currentYear, customStorage, formatDateTime, getAvailableMonths, getChangingSelectColor, getPayloadData,
    handleFromMonthChange, handleFromYearChange, handleToMonthChange, handleToYearChange, isInRole, isNullOrEmptyString, years
} from '../../services/UtilityService';
import { finishOrder, getOrderList } from '../../services/ManagementService';
import { DELI_TYPE_DEFINE, DELI_TYPES, ORDER_STATE, ORDER_STATE_DEFINE, ORDER_STATUS, ORDER_STATUS_DEFINE, SELECT_ALL_DEFAULT, SELECT_DEFAULT, SERVER_ERROR_MESSAGE, TBL_DATA_SEPARATOR, TOKEN_SESSION_KEY } from '../../constants/commonConstants';
import useScrollRestoration from '../../share-components/UseScrollRestoration';
import SearchColumnSelect from '../../share-components/SearchColumnSelect';
import NoDataFound from '../../share-components/NoDataFound';
import FormTitle from '../../share-components/FormTitle';
import ConfirmDialog from '../../share-components/ConfirmDialog';
import AlertDialog from '../../share-components/AlertDialog';
import { getAllActiveUsers } from '../../services/CommonService';
import noImage from '../../assets/No_Image_Available.jpg';
import { RG_ADMIN_ONLY } from '../../constants/roleConstants';

const OrderList = () => {

    useScrollRestoration(PAGE_ORDER_LIST);

    const token = customStorage.getItem(TOKEN_SESSION_KEY);
    const currentUser = getPayloadData(token);

    const initialSearchDataObj = sessionStorage.getItem(ROUTE_ORDER_LIST);
    const initialSearchData = initialSearchDataObj ? JSON.parse(initialSearchDataObj) : null;

    const { loading, setLoading, setShowApiErrorMessage, setRouteNaviData, setPictureIncludedProductIdList, productPictureList } = useAppContext();
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const [orderedList, setOrderedList] = useState([]);


    const [activeUsers, setActiveUsers] = useState([]);
    const [paymentReceivedById, setPaymentReceivedById] = useState(initialSearchData?.paymentReceivedById || "");
    const [deliveredById, setDeliveredById] = useState(initialSearchData?.deliveredById || "");
    const [deliType, setDeliType] = useState(initialSearchData?.deliType || "");
    const [orderedById, setOrderedById] = useState(initialSearchData?.orderedById || "");
    const [orderState, setOrderState] = useState(initialSearchData?.orderState || ORDER_STATE_DEFINE.pending.value.toString());
    const [fromYear, setFromYear] = useState(initialSearchData?.fromYear || currentYear);
    const [fromMonth, setFromMonth] = useState(initialSearchData?.fromMonth || currentMonth);
    const [toYear, setToYear] = useState(initialSearchData?.toYear || currentYear);
    const [toMonth, setToMonth] = useState(initialSearchData?.toMonth || currentMonth);
    const [afterSearchOrderState, setAfterSearchOrderState] = useState(initialSearchData?.orderState || ORDER_STATE_DEFINE.pending.value.toString());

    const [orderListTableData, setOrderListTableData] = useState([]);

    const [filteredData, setFilteredData] = useState([]);
    const [searchData, setSearchData] = useState(null);

    const [showFinishOrderConfirmDialog, setShowFinishOrderConfirmDialog] = useState(false);
    const [finishOrderId, setFinishOrderId] = useState(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const [summaryInfo, setSummaryInfo] = useState({});

    const [afterGetDataStore, setAfterGetDataStore] = useState({
        orderedById: initialSearchData?.orderedById || "",
        paymentReceivedById: initialSearchData?.paymentReceivedById || "",
        deliveredById: initialSearchData?.deliveredById || "",
        deliType: initialSearchData?.deliType || "",
        orderState: initialSearchData?.orderState || ORDER_STATE_DEFINE.pending.value.toString(),
        fromYear: initialSearchData?.fromYear || currentYear,
        fromMonth: initialSearchData?.fromMonth || currentMonth,
        toYear: initialSearchData?.toYear || currentYear,
        toMonth: initialSearchData?.toMonth || currentMonth
    });

    const navigate = useNavigate();

    //     const summaryAccordionBodyRef = useRef(null);
    //     const [summaryAccordionHeaderWidth, setSummaryAccordionHeaderWidth] = useState(null);

    //     React.useEffect(() => {
    //     if (summaryAccordionBodyRef.current) {
    //       setSummaryAccordionHeaderWidth(summaryAccordionBodyRef.current.scrollWidth);
    //     }
    //   }, [summaryInfo]);


    useEffect(() => {
        const searchData = {
            orderedById: orderedById,
            paymentReceivedById: paymentReceivedById,
            deliveredById: deliveredById,
            deliType: deliType,
            orderState,
            fromYear,
            fromMonth,
            toYear,
            toMonth
        };
        setSearchData(searchData);
    }, [loading]);

    const fetchOrderList = async () => {
        setLoading(true);
        try {
            const formData = {
                orderedById: orderedById || null,
                paymentReceivedById: paymentReceivedById || null,
                deliveredById: deliveredById || null,
                deliType: deliType ? (parseInt(deliType, 10) || null) : null,
                orderState: parseInt(orderState) || null,
                fromYear: parseInt(fromYear) || 0,
                fromMonth: parseInt(fromMonth) || 0,
                toYear: parseInt(toYear) || 0,
                toMonth: parseInt(toMonth) || 0
            }
            const response = await getOrderList(formData);
            setPictureIncludedProductIdList(response?.pictureIncludedProductIdList || []);

            const convertedResponse = (response?.orderedInfoList || [])?.sort((a, b) => b?.lastUpdatedDateTime?.localeCompare(a?.lastUpdatedDateTime))?.map((order) => ({
                ...order,
                orderedDate: formatDateTime(order?.createdDateTime?.slice(0, 8)),
                orderStatusText: ORDER_STATUS.find(status => status.value === parseInt(order.orderStatus))?.text || '',
                updatedDate: formatDateTime(order?.lastUpdatedDateTime?.slice(0, 8)),
            }))
            setOrderedList(convertedResponse || []);
            setAfterSearchOrderState(orderState);

            const afterGetData = {
                orderedById,
                paymentReceivedById,
                deliveredById,
                deliType,
                orderState,
                fromYear,
                fromMonth,
                toYear,
                toMonth
            }
            setAfterGetDataStore(afterGetData);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setRouteNaviData("ORDER >> ORDER LIST");
        initialLoad();
    }, []);

    const initialLoad = async () => {
        setLoading(true);
        try {
            const response = await getAllActiveUsers();
            const sortedUsers = (response || [])?.sort((a, b) => (a.username || "")?.localeCompare((b?.username || "")));
            setActiveUsers(sortedUsers);
            await fetchOrderList();
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const convertedResponse = (orderedList || []).map((oData) => ({
            ...oData,
            showData: getShowData(oData)
        }));
        setOrderListTableData(convertedResponse);
    }, [orderedList, productPictureList])

    const getOrderedItemCount = (orderedProductInfos) => {
        const orderedItemCount = (orderedProductInfos || []).reduce((sum, order) => sum + order.quantity, 0);
        return orderedItemCount;
    }

    const getDeliveryFee = (deliType, deliFee) => {
        const deliTypeValue = parseInt(deliType) || null;
        deliFee = parseInt(deliFee) || 0;
        const deliFeeShow = deliTypeValue === DELI_TYPE_DEFINE.prepaidDelivery.value ? `${deliFee}¥` : DELI_TYPES.find(deli => deli.value === deliTypeValue)?.text;
        return deliFeeShow;
    }

    const getShowData = (orderData) => {
        const orderStatusText = Object.values(ORDER_STATUS_DEFINE).find((status) => status.value === orderData?.orderStatus)?.text || "";
        const productSearchInfo = (orderData?.orderedProductInfos || []).map(item =>
            [item.brandName || "", item.categoryName || "", item.productName || "", item.color ? `[${item.color}]` : "", item.size ? `[${item.size}]` : ""] || []
        );

        const plainText = [
            orderData?.customerName || "",
            orderStatusText,
            `Deli: ${orderData?.deliveredBy || ""} (${getDeliveryFee(orderData?.deliveryType, orderData?.deliveryFee)})`,
            orderData?.subtotal ? `Subtotal: ${orderData.subtotal}￥${orderData.subtotal}¥` : "0￥0¥",
            (orderData?.serviceCharge || 0) > 0 ? `Service Charge: ${orderData.serviceCharge}￥${orderData.serviceCharge}¥` : "",
            (orderData?.tipMoney || 0) > 0 ? `Tip Money: ${orderData.tipMoney}￥${orderData.tipMoney}¥` : "",
            (orderData?.prGiftAmount || 0) > 0 ? `PR Gift: ${orderData.prGiftAmount}￥${orderData.prGiftAmount}¥` : "",
            (!isNullOrEmptyString(orderData?.paymentReceivedBy)) ? `${orderData?.paymentReceivedBy} (${orderData.paymentReceivedAmount || 0}￥)(${orderData.paymentReceivedAmount || 0}¥)` : "",
            // orderData?.orderedBy || "",
            formatDateTime(orderData?.createdDateTime) || "",
            orderData?.createdDateTime !== orderData?.lastUpdatedDateTime ? formatDateTime(orderData?.lastUpdatedDateTime) || "" : "",
            productSearchInfo.join(TBL_DATA_SEPARATOR),

        ].filter(Boolean).join(TBL_DATA_SEPARATOR); // Join all values into a single string

        return {
            jsx: (
                <div style={{ fontWeight: '600' }}>
                    <div className='main-name-block'><i className='bi bi-emoji-heart-eyes'></i> {orderData?.customerName} <i className='bi bi-emoji-heart-eyes'></i></div><hr className='m-0' />
                    <div><i className='bi bi-journal-bookmark'></i> {orderStatusText}</div><hr className='m-0' />
                    <><div><i className='bi bi-truck-flatbed'></i> Deli: {orderData?.deliveredBy || ""} ({getDeliveryFee(orderData?.deliveryType, orderData?.deliveryFee)})</div><hr className='m-0' /></>
                    <div><i className='bi bi-cash'></i> Subtotal: {orderData?.subtotal || 0}¥</div><hr className='m-0' />
                    {(orderData?.serviceCharge || 0) > 0 && <><div><i className='bi bi-cash-coin'></i> Service Charge: {orderData?.serviceCharge || 0}¥</div><hr className='m-0' /></>}
                    {(orderData?.tipMoney || 0) > 0 && <><div><i className='bi bi-coin'></i> Tip Money: {orderData?.tipMoney || 0}¥</div><hr className='m-0' /></>}
                    {(orderData?.prGiftAmount || 0) > 0 && <><div style={{ color: "blue" }}><i className='bi bi-gift'></i> PR Gift: {orderData?.prGiftAmount || 0}¥</div><hr className='m-0' /></>}
                    {(!isNullOrEmptyString(orderData?.paymentReceivedBy)) && <><div><i className='bi bi-wallet2'></i> {orderData?.paymentReceivedBy} ({orderData?.paymentReceivedAmount || 0}¥)</div><hr className='m-0' /></>}
                    <div><i className='bi bi-person-add'></i> {orderData?.orderedBy}</div><hr className='m-0' />
                    <div><i className='bi bi-shop'></i> {formatDateTime(orderData?.createdDateTime)}</div><hr className='m-0' />
                    {orderData?.orderedById !== orderData?.lastUpdatedById && <><div><i className='bi bi-person-gear'></i> {orderData?.lastUpdatedBy}</div><hr className='m-0' /></>}
                    {orderData?.createdDateTime !== orderData?.lastUpdatedDateTime && <><div><i className='bi bi-alarm'></i> {formatDateTime(orderData?.lastUpdatedDateTime)}</div><hr className='m-0' /></>}
                    {orderData?.comment && <div className='stockAccordion no-pad mb-1'>
                        <Accordion >
                            <Accordion.Item eventKey="0" >
                                <Accordion.Header>
                                    <div>
                                        <i className='bi bi-chat-dots'></i> Comment
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='stockAndInStockDetailsBlock p-2'>
                                        {orderData?.comment}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <hr className='m-0' />
                    </div>}
                    <div className='stockAccordion no-pad'>
                        <Accordion>
                            <Accordion.Item eventKey="0" >
                                <Accordion.Header>
                                    {/* <div>
                                        <i className='bi bi-bag-check'></i> Order ({(orderData?.orderedProductInfos || []).length}) Item{(orderData?.orderedProductInfos || []).length > 1 ? 's' : ''}
                                    </div> */}
                                    <div>
                                        <i className='bi bi-bag-check'></i> Order ({getOrderedItemCount(orderData?.orderedProductInfos)}) Item{getOrderedItemCount(orderData?.orderedProductInfos) > 1 ? 's' : ''}
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='stockAndInStockDetailsBlock'>
                                        {(orderData?.orderedProductInfos || []).map((pInfo, index) => {
                                            const productPicture = productPictureList?.find(data => data.productId == pInfo.productId)?.productPicture;

                                            return (
                                                <div key={index} style={{
                                                    border: "1px solid black",
                                                    padding: "5px",
                                                    marginBottom: "1px",
                                                    borderRadius: "5px"
                                                }}>
                                                    <div style={{ display: 'flex' }}>
                                                        <div style={{ paddingRight: '10px', flex: "1" }}>
                                                            <div><i className='bi bi-award'></i> {pInfo?.brandName}</div><hr className='m-0' />
                                                            <div><i className='bi bi-box'></i> {pInfo?.productName}</div><hr className='m-0' />
                                                            <div><i className='bi bi-tags'></i> {pInfo?.categoryName}</div><hr className='m-0' />
                                                            {(!isNullOrEmptyString(pInfo?.size) || !isNullOrEmptyString(pInfo.color)) &&
                                                                <>
                                                                    <div>
                                                                        <i className='bi bi-palette'></i> {!isNullOrEmptyString(pInfo.color) && <span>[{pInfo.color}]</span>}{!isNullOrEmptyString(pInfo?.size) && <span>[{pInfo.size}]</span>}

                                                                    </div><hr className='m-0' />
                                                                </>
                                                            }
                                                            <div><i className='bi bi-cash'></i><span> ({(pInfo.salePrice || 0)}¥)x({pInfo.quantity})</span></div>
                                                        </div>
                                                        <div style={{ paddingTop: "5px" }}>
                                                            <img
                                                                src={productPicture ? `data:image/jpeg;base64,${productPicture}` : noImage}
                                                                alt="picture"
                                                                className="img-thumbnail"
                                                                style={{ width: "var(--orderProductPictureWidth)", height: "var(--orderProductPictureHeight)", objectFit: "cover" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <hr className='m-0' />
                    </div>
                </div>
            ),
            text: plainText.toLowerCase() // Store searchable text
        };
    };

    const handleFinish = async () => {
        const orderId = parseInt(finishOrderId) || 0;
        try {
            setShowFinishOrderConfirmDialog(false);
            setLoading(true);
            await finishOrder(orderId);
            setShowSuccessDialog(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    }

    const handleSuccessDialogClose = async () => {
        setShowSuccessDialog(false);
        await fetchOrderList();
    }

    const filteredColumns = useMemo(() => {
        const columns = [
            {
                Header: 'Order Infos',
                accessor: 'showData',
                disableSortBy: true,
                style: {
                    minWidth: "150px",
                    maxWidth: "350px",
                },
                Cell: ({ row }) => row.original.showData.jsx,
            },
            {
                Header: 'Finish',
                accessor: 'finish',
                unSearchable: true,
                disableSortBy: true,
                headerClassName: 'disableSort text-center',
                className: 'text-center align-middle',
                style: {
                    minWidth: "50px",
                    // maxWidth: "100px"
                },
                Cell: ({ row }) => (
                    <div className='center-block'>
                        {(  isInRole(RG_ADMIN_ONLY, currentUser?.role) &&
                            row.original?.deliveredById === currentUser?.userId &&
                            row.original?.orderStatus === ORDER_STATUS_DEFINE.shipped.value) ?
                            <Button
                                variant="success"
                                className="btn-sm icon-btn-vertical"
                                onClick={() => {
                                    setFinishOrderId(row.original?.orderId);
                                    setShowFinishOrderConfirmDialog(true);
                                }}
                            >
                                <i className="bi bi-check-circle-fill"></i>
                                <span>Finish</span>
                            </Button> :
                            <Button variant="danger" disabled
                                className="btn-sm icon-btn-vertical">
                                <i className="bi bi-ban"></i>
                                <span>Disabled</span>
                            </Button>
                        }
                    </div>
                ),
            },
            {
                Header: 'Edit',
                accessor: 'edit',
                unSearchable: true,
                disableSortBy: true,
                headerClassName: 'disableSort text-center',
                className: 'text-center align-middle',
                style: {
                    minWidth: "50px",
                    // maxWidth: "100px"
                },
                Cell: ({ row }) => (
                    <div className='center-block'>
                        {( isInRole(RG_ADMIN_ONLY, currentUser?.role) &&
                            row.original?.orderedById === currentUser?.userId &&
                            row.original?.orderStatus !== ORDER_STATUS_DEFINE.finished.value &&
                            row.original?.orderStatus !== ORDER_STATUS_DEFINE.cancelled.value) ?
                            <Button
                                variant="secondary"
                                className="btn-sm icon-btn-vertical"
                                onClick={() => navigate(`${ROUTE_ORDER_EDIT}/${row.original.orderId}`)}
                            >
                                <i className="bi bi-pencil-square"></i>
                                <span>Edit</span>
                            </Button> :
                            (isInRole(RG_ADMIN_ONLY, currentUser?.role) && row.original?.deliveredById === currentUser?.userId) ?
                                <Button
                                    variant="secondary"
                                    className="btn-sm icon-btn-vertical"
                                    onClick={() => navigate(`${ROUTE_ORDER_DELI_EDIT}/${row.original.orderId}`)}
                                >
                                    <i className="bi bi-pencil-square"></i>
                                    <span>Edit Deli</span>
                                </Button> :
                                <Button variant="danger" disabled
                                    className="btn-sm icon-btn-vertical">
                                    <i className="bi bi-ban"></i>
                                    <span>Disabled</span>
                                </Button>
                        }
                    </div>
                ),
            },
            {
                Header: 'Details',
                accessor: 'details',
                unSearchable: true,
                disableSortBy: true,
                headerClassName: 'disableSort text-center',
                className: 'text-center align-middle',
                style: {
                    // minWidth: "70px",
                    // maxWidth: "100px"
                },
                Cell: ({ row }) => (
                    <div className='center-block'>
                        <Button
                            variant="secondary"
                            className="btn-sm icon-btn-vertical"
                            onClick={() => navigate(`${ROUTE_ORDER_DETAILS}/${row.original.orderId}`)}
                        >
                            <i className="bi bi-info-circle"></i>
                            <span>Details</span>
                        </Button>
                    </div>
                ),
            }
        ];
        const afterSearchState = parseInt(afterSearchOrderState) || 0;
        if (afterSearchState === ORDER_STATE_DEFINE.finished.value || afterSearchState === ORDER_STATE_DEFINE.cancelled.value) {
            const result = columns.filter(c => c.accessor !== 'edit' && c.accessor !== 'finish');
            return result;
        } else {
            return columns;
        }
    }, [afterSearchOrderState, filteredData])

    const handleGetOrderData = async () => {
        await fetchOrderList();
    }

    const isPending = () => {
        const result = orderState !== ORDER_STATE_DEFINE.finished.value.toString() && orderState !== ORDER_STATE_DEFINE.cancelled.value.toString();
        return result;
    }

    useEffect(() => {
        const listData = filteredData || [];
        const totalPaymentReceivedAmount = listData?.reduce((sum, item) => sum + item.paymentReceivedAmount, 0);
        const totalDeliveryFee = listData?.reduce((sum, item) => sum + item.deliveryFee, 0);
        const totalServiceCharge = listData?.reduce((sum, item) => sum + item.serviceCharge, 0);
        const totalTipMoney = listData?.reduce((sum, item) => sum + item.tipMoney, 0);
        const totalPrGiftAmount = listData?.reduce((sum, item) => sum + item.prGiftAmount, 0);
        const totalProductQuantity = listData.reduce((finalSum, item) => {
            return (
                finalSum +
                item.orderedProductInfos.reduce((productSum, product) => productSum + product.quantity, 0)
            );
        }, 0);
        const summary = {
            totalPaymentReceivedAmount,
            totalDeliveryFee,
            totalServiceCharge,
            totalTipMoney,
            totalPrGiftAmount,
            totalProductQuantity
        }
        setSummaryInfo(summary);
    }, [filteredData]);

    return (
        <div id='orderListPage'>
            <FormTitle title={`${ORDER_STATE.find(state => state.value === parseInt(afterSearchOrderState))?.text} Order List`} isCenter={true} />
            {isFirstLoaded && <>
                {(afterSearchOrderState === ORDER_STATE_DEFINE.finished.value.toString() || afterSearchOrderState === ORDER_STATE_DEFINE.cancelled.value.toString()) && <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {afterGetDataStore?.fromYear}/{afterGetDataStore?.fromMonth} ～ {afterGetDataStore?.toYear}/{afterGetDataStore?.toMonth}
                </div>}
                <div style={{ overflow: "auto", paddingBottom: "50px" }}>
                    <div style={{ minWidth: "max-content", maxWidth: "650px", margin: '0 auto' }}>
                        <Card>
                            <Card.Body style={{ padding: '10px 5px 20px 5px' }}>
                                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="orderedBy" style={{ minWidth: "50px" }}>
                                            Ordered By
                                        </label>
                                        <div>
                                            <select
                                                id="orderedBy"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(orderedById, afterGetDataStore?.orderedById)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={orderedById}
                                                onChange={(e) => setOrderedById(e.target.value)}
                                            >
                                                <option value={""}>{SELECT_ALL_DEFAULT}</option>
                                                {activeUsers.map(activeUser => (
                                                    <option key={activeUser.userId} value={activeUser.userId}>{activeUser.username}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="paymentReceivedBy" style={{ minWidth: "50px" }}>
                                            Pay Received By
                                        </label>
                                        <div>
                                            <select
                                                id="paymentReceivedBy"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(paymentReceivedById, afterGetDataStore?.paymentReceivedById)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={paymentReceivedById}
                                                onChange={(e) => setPaymentReceivedById(e.target.value)}
                                            >
                                                <option value={""}>{SELECT_ALL_DEFAULT}</option>
                                                {activeUsers.map(activeUser => (
                                                    <option key={activeUser.userId} value={activeUser.userId}>{activeUser.username}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="deliveredBy" style={{ minWidth: "50px" }}>
                                            Delivered By
                                        </label>
                                        <div>
                                            <select
                                                id="deliveredBy"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(deliveredById, afterGetDataStore?.deliveredById)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={deliveredById}
                                                onChange={(e) => setDeliveredById(e.target.value)}
                                            >
                                                <option value={""}>{SELECT_ALL_DEFAULT}</option>
                                                {activeUsers.map(activeUser => (
                                                    <option key={activeUser.userId} value={activeUser.userId}>{activeUser.username}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="deliType" style={{ minWidth: "50px" }}>
                                            Delivery Type
                                        </label>
                                        <div>
                                            <select
                                                id="deliType"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(deliType, afterGetDataStore?.deliType)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={deliType}
                                                onChange={(e) => setDeliType(e.target.value)}
                                            >
                                                <option value={""}>{SELECT_ALL_DEFAULT}</option>
                                                {DELI_TYPES.map(type => (
                                                    <option key={type.value} value={type.value}>{type.text}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                    <div className="d-inline-block">
                                        <label className="custom-label" htmlFor="orderState" style={{ minWidth: "50px" }}>
                                            Order Status
                                        </label>
                                        <div>
                                            <select
                                                id="orderState"
                                                className={`customInputControl select-min-max-width ${getChangingSelectColor(orderState, afterGetDataStore?.orderState)}`}
                                                style={{
                                                    minWidth: '135px',
                                                    maxWidth: '150px'
                                                }}
                                                value={orderState}
                                                onChange={(e) => setOrderState(e.target.value)}
                                            >
                                                {ORDER_STATE.map(state => (
                                                    <option key={state.value} value={state.value}>{state.text}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {!isPending() &&
                                    <div className="mt-1 mb-1" style={{ display: "flex", gap: "10px", justifyContent: "start", alignItems: "end", flexWrap: "wrap" }}>
                                        {/* From Year & Month */}
                                        <div className="d-inline-block">
                                            <label className="me-1 custom-label" htmlFor="fromYear" style={{ minWidth: "50px" }}>
                                                From
                                            </label>
                                            <div>
                                                <select
                                                    id="fromYear"
                                                    className={`customInputControl ${getChangingSelectColor(fromYear, afterGetDataStore?.fromYear)}`}
                                                    value={fromYear}
                                                    onChange={(e) => handleFromYearChange(e, fromMonth, toYear, toMonth, setFromYear, setFromMonth, setToYear, setToMonth)}
                                                >
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>
                                                <span className="separator">/</span>
                                                <select
                                                    id="fromMonth"
                                                    className={`customInputControl ${getChangingSelectColor(fromMonth, afterGetDataStore?.fromMonth)}`}
                                                    value={fromMonth}
                                                    onChange={(e) => handleFromMonthChange(e, fromYear, toYear, toMonth, setFromMonth, setToMonth)}
                                                >
                                                    {getAvailableMonths(fromYear).map((month) => (
                                                        <option key={month} value={month}>
                                                            {month.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* To Year & Month */}
                                        <div className="d-inline-block">
                                            <label className="me-1 custom-label" htmlFor="toYear" style={{ minWidth: "50px" }}>
                                                To
                                            </label>
                                            <div>
                                                <select
                                                    id="toYear"
                                                    className={`customInputControl ${getChangingSelectColor(toYear, afterGetDataStore?.toYear)}`}
                                                    value={toYear}
                                                    onChange={(e) => handleToYearChange(e, fromYear, fromMonth, toMonth, setFromYear, setToYear, setFromMonth)}
                                                >
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>{year}</option>
                                                    ))}
                                                </select>
                                                <span className="separator">/</span>
                                                <select
                                                    id="toMonth"
                                                    className={`customInputControl ${getChangingSelectColor(toMonth, afterGetDataStore?.toMonth)}`}
                                                    value={toMonth}
                                                    onChange={(e) => handleToMonthChange(e, fromYear, fromMonth, toYear, setFromMonth, setToMonth)}
                                                >
                                                    {getAvailableMonths(toYear).map((month) => (
                                                        <option key={month} value={month}>
                                                            {month.toString().padStart(2, "0")}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                    </div>}

                                <div className="d-inline">
                                    <button type='button' className="btn btn-success btn-sm appBtn" onClick={handleGetOrderData}>Get Data</button>
                                </div>

                                <div className='summaryAccordion mt-1'>
                                    <Accordion  >
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>
                                                <div style={{ minWidth: '258px' }}>
                                                    Summary Info
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div>
                                                    <table className='table table-bordered auto-width-table'>
                                                        <tbody>
                                                            <tr><td>Payment Received Amount:</td><td>{summaryInfo?.totalPaymentReceivedAmount}¥</td></tr>
                                                            <tr><td>Delivery Fee:</td><td>{summaryInfo?.totalDeliveryFee}¥</td></tr>
                                                            <tr><td>Service Charge:</td><td>{summaryInfo?.totalServiceCharge}¥</td></tr>
                                                            <tr><td>Tip Money:</td><td>{summaryInfo?.totalTipMoney}¥</td></tr>
                                                            <tr><td>PR Gift Amount:</td><td>{summaryInfo?.totalPrGiftAmount}¥</td></tr>
                                                            <tr><td>Product Quantity:</td><td>{summaryInfo?.totalProductQuantity}</td></tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>

                                <div style={{ marginBottom: '10px', marginTop: '10px', display: 'flex', justifyContent: 'start', alignItems: 'end', flexWrap: 'wrap', gap: '5px' }}>
                                    <SearchColumnSelect data={orderListTableData} setData={setFilteredData} columns={filteredColumns}
                                        isNoColumn={true} storeSessionKey={ROUTE_ORDER_LIST} sessionData={searchData} />
                                </div>
                                {filteredData?.length > 0 ?

                                    <CustomTable
                                        tableId='orderListTbl'
                                        columns={filteredColumns}
                                        tblData={filteredData || []}
                                        showPagination={true}
                                        itemsPerPage={10}
                                        noHeader={true}
                                        isStorePageData={true}
                                    />

                                    : <NoDataFound />}
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <ConfirmDialog
                    dialogId='finishOrderConfirmDialog'
                    showDialog={showFinishOrderConfirmDialog}
                    // title='Logout Dialog'
                    body='Are you sure this order is finished?'
                    onConfirm={handleFinish}
                    onCancel={() => { setShowFinishOrderConfirmDialog(false); setFinishOrderId(null); }}
                />

                <AlertDialog
                    dialogId={'successDialog'}
                    showDialog={showSuccessDialog}
                    body={'Order is successfully finished.'}
                    onConfirm={handleSuccessDialogClose}
                />
            </>}
        </div>
    );
};

export default OrderList;